import React, { Component } from 'react';
import { isEqual } from 'lodash';
import { withTheme } from 'styled-components';
import { AbstractChart } from 'containers/charts/AbstractChart';
import helpers from 'helpers';
import ContentTile from 'components/atoms/layout/ContentTile';
import ContentHeader from 'components/atoms/layout/ContentHeader';

class StackedAreaChart extends Component {
    constructor(props) {
        super(props);
        this.chartRef = React.createRef();
    }

    shouldComponentUpdate(nextProps) {
        return !isEqual(this.props, nextProps);
    }

    render() {
        const series = [];
        const { chartRef } = this;
        const { orderedColors } = this.props.theme;

        Object.keys(this.props.data).forEach((key, index) => {
            let completeData;
            if (!this.props.categories) {
                completeData = helpers.backfill(
                    this.props.data[key].map(r => ({ x: r.date_in_ms, y: r[this.props.y] })),
                    this.props.backfillBuckets
                );
            } else {
                completeData = this.props.data[key].map(r => r[this.props.y]);
            }

            series.push({
                ...(this.props.yOptions || {}),
                name: helpers.convertToDisplayValue(key),
                color: orderedColors[index % orderedColors.length],
                data: completeData
            });
        });

        const xAxis = helpers.xAxisConfig({
            type: this.props.xAxisType,
            xAxisLabel: this.props.xAxisLabel,
            options: { categories: this.props.categories }
        });

        const yAxis = helpers.yAxisConfig({
            yAxisLabel: this.props.yTitle || this.props.y,
            options: { ...(this.props.yAxisOptions || {}) }
        });

        const plotOptions = {
            series: {
                animation: {
                    duration: this.props.animateDuration
                }
            },
            area: { stacking: 'normal' }
        };

        return (
            <ContentTile padding={helpers.contentPadding('chart-with-legend')}>
                <ContentHeader chartRef={chartRef} type={'chart'}>{this.props.title}</ContentHeader>
                <AbstractChart
                    ref={chartRef}
                    exportName={this.props.exportName}
                    config={{
                        meta: {
                            title: this.props.title
                        },
                        chart: {
                            type: 'area',
                            zoomType: 'xy'
                        },
                        exporting: helpers.commonExportingConfig(this.props.exportName),
                        credits: {
                            enabled: false
                        },
                        plotOptions,
                        title: {
                            text: null
                        },
                        tooltip: {
                            split: true,
                            crosshairs: {
                                width: 1,
                                color: 'gray',
                                dashStyle: 'shortdot'
                            },
                            // sort tooltip values
                            formatter(tooltip) {
                                const items = this.points;
                                items.sort((a, b) => {
                                    let res;
                                    if (a.y < b.y) {
                                        res = -1;
                                    } else if (a.y > b.y) {
                                        res = 1;
                                    } else {
                                        res = 0;
                                    }
                                    return res;
                                });
                                items.reverse();
                                return tooltip.defaultFormatter.call(this, tooltip);
                            },
                            ...(this.props.toolTipOptions || {})
                        },
                        legend: {
                            padding: 10,
                            itemStyle: {
                                color: this.props.theme.charts.axisAssets
                            }
                        },
                        xAxis,
                        yAxis,
                        series
                    }} />
            </ContentTile>
        );
    }
}

export default withTheme(StackedAreaChart);



// WEBPACK FOOTER //
// ./src/components/molecules/charts/StackedAreaChart.js